import Chip from "@medoma/components/Chip/Chip";
import CustomProperties from "@medoma/components/CustomProperties/CustomProperties";
import { Trans } from "@lingui/react/macro";
import styles from "./DurationChip.module.scss";

type DurationLength = "short" | "medium" | "long";

const getDurationLength = (minutes: number): DurationLength => {
  if (minutes <= 30) {
    return "short";
  }
  if (minutes <= 60) {
    return "medium";
  }
  return "long";
};

type IDurationChip = {
  minutes: number;
} & Pick<Parameters<typeof Chip>[0], "size">;

const DurationChip = ({ minutes, size = "tiny" }: IDurationChip) => {
  const length = getDurationLength(minutes);
  return (
    <CustomProperties className={styles[`${length}-duration`]}>
      <Chip background="solid" border="none" size={size} shape="sharp">
        <div className={styles.durationText}>
          <Trans>~{minutes} min</Trans>
        </div>
      </Chip>
    </CustomProperties>
  );
};

export default DurationChip;
